/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowsUpRight = createReactComponent("arrows-up-right", "IconArrowsUpRight", [
  ["path", { d: "M17 21l4 -4l-4 -4", key: "svg-0" }],
  ["path", { d: "M21 17h-11a3 3 0 0 1 -3 -3v-11", key: "svg-1" }],
  ["path", { d: "M11 7l-4 -4l-4 4", key: "svg-2" }]
]);

export { IconArrowsUpRight as default };
//# sourceMappingURL=IconArrowsUpRight.js.map
